<section class="grid-section">
  @if (reportGridData) {
    <section class="report-grid-wrapper">
      @if (reportGridData.message) {
        <div class="no-content">
          @if (!reportGridData.link) {
            @if (reportGridData.message) {
              <span>{{ reportGridData.message }}</span>
            }
          } @else {
            <span class="download-report">
              <a aria-label="download report" [href]="reportGridData.link">
                {{ reportGridData.message }}
              </a>
            </span>
          }
        </div>
      } @else {
        @if (reportGridData.lines?.length == 0) {
          <div class="no-content">
            <span>
              {{ reportGridData.isQaMode ? 'Product data is correct' : 'No information found' }}
            </span>
          </div>
        }
        @if (reportGridData?.error || reportGridData?.timeout_message) {
          <div class="message">
            @if (reportGridData.error) {
              {{ reportGridData.error }}
            }
            @if (reportGridData.timeout_message) {
              {{ reportGridData.timeout_message }}
            }
          </div>
        }
      }
      @if (reportGridData.lines) {
        @if (selectedRow.length) {
          <div class="bulk-actions">
            <button
              role="button"
              mat-fab
              color="primary"
              matTooltip="Refresh Report"
              aria-label="Refresh Report"
              class="primary-button bulk-refresh-button"
              (click)="reloadReport()"
            >
              <mat-icon aria-hidden="true">refresh</mat-icon>
            </button>
          </div>
        }
        @if (reportGridData.lines.length > 0 && gridOptions) {
          <div class="grid-container">
            <mds-grid
              [themeClass]="'ag-theme-material'"
              [overrides]="gridOptions"
              [minHeight]="'100%'"
              [showDefaultCharts]="showDefaultCharts"
              [reportName]="reportData?.reportDataPanelTitle"
              [templateData]="templateData"
              [savedGridSetting]="gridSettings"
              [resizeColumnsByContent]="true"
              [enableMinWidthToColumns]="true"
              (cellKeyPress)="onCellKeyPressed($event)"
            ></mds-grid>
          </div>
        }
      }
    </section>
  } @else {
    @if (loading) {
      <div class="loader">
        <div>
          <mds-icon [key]="icons.LOADING" [height]="45" [width]="45"></mds-icon>
        </div>
        <div class="message">
          {{ loadingMessage }}
        </div>
      </div>
    } @else if (!reportGridData && !loading && loadingMessage) {
      <div class="loader">
        <div class="message">
          {{ loadingMessage }}
        </div>
      </div>
    } @else if (templateBody && !reportGridData && !loading) {
      <div class="no-content">
        <span>{{ templateBody.body }}</span>
      </div>
    }
  }
</section>
